import React, { useState } from "react";
import "./warehouseList.css";
// components imports
import WarehousesTable from "../../../../../../Components/BoltTable/BoltTable";
import WarehouseClientList from "../Components/WarehouseClientList/WarehouseClientList";
import WarehouseProductList from "../Components/WarehouseProductList/WarehouseProductList";
import WarehouseDetails from "../Components/WarehouseDetails/WarehouseDetails";
import AddBalance from "../../AddBalance/AddBalance";
import SubtractBalance from "../../SubtractBalance/SubtractBalance";
import PaymentsHistory from "../../PaymentsHistory/PaymentsHistory";
import ChangePassword from "../../ChangePassword/ChangePassword";
import EditUser from "../../EditUser/EditUser";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import SwitchButton from "../../../../../../Components/SwitchButton/SwitchButton";
import Confirm from "../../../../../../Components/Popups/Confirm";
import ManageWarehouseFormula from "../Components/ManageWarehouseFormula/ManageWarehouseFormula";
import InvoicesHistory from "../../InvoicesHistory/InvoicesHistory";
// apis imports
import {
  getAllWarehouseUsers,
  changeWarehouseStatus,
  updateAccountStatus,
  deleteUserByAdmin,
} from "../../../../../../services/AdminServices/Users/users.services";
// library imports
import { IoInformationCircleOutline } from "react-icons/io5";
import { IconButton } from "@mui/material";
import CustomMenu from "../Components/ActionsDropDown/ActionsDropDown";
import { convertTime } from "../../../../../../helpers/helpers";
import HelperUserList from "../../HelperUserList/HelperUserList";
import { useTranslation } from "react-i18next";

const WarehouseList = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [searchLoader, setSearchLoader] = useState(false);

  const [warehouses, setWarehouses] = useState();

  const [openClientsModal, setOpenClientsModal] = useState(false);
  const [openHelperUsersModal, setOpenHelperUsersModal] = useState(false);
  const [openProductsModal, setOpenProductsModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [addBalanceModal, setAddBalanceModal] = useState(false);
  const [subtractBalanceModal, setSubtractBalanceModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState();
  const [statusUpdating, setStatusUpdating] = useState();
  const [formulaModal, setFormulaModal] = useState(false);
  const [invoicesHistoryModal, setInvoicesHistoryModal] = useState(false);

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("users.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.code"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.email"),
      render: (row) => <>{row?.user?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("users.balanceColumn"),
      render: (row) => <>{row?.user?.balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: (
        <>
          {t("users.threePlActivation")}
          <Tooltip title={t("users.threePlApproved")}>
            <IconButton>
              <IoInformationCircleOutline size={10} />
            </IconButton>
          </Tooltip>
        </>
      ),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleStatusChange(e, row)}
            checked={row?.status === "active" ? true : false}
            disabled={searchLoader === "WarehouseActivation" ? true : false}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: (
        <>
          {t("users.activate")}
          <Tooltip title={t("users.accountApprovedDisapproved")}>
            <IconButton>
              <IoInformationCircleOutline size={10} />
            </IconButton>
          </Tooltip>
        </>
      ),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleUserStatusChange(e, row)}
            checked={
              ![false, "false", "0", null, undefined].includes(
                row?.user?.account_status,
              )
            }
            disabled={searchLoader === "UserActivation" ? true : false}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 7,
      label: t("users.clients"),
      render: (row) => <>{row?.warehouse_users_count}</>,
      width: "200px",
    },
    {
      id: 8,
      label: t("users.helperUsers"),
      render: (row) => <>{row?.user?.children_count}</>,
      width: "200px",
    },
    {
      id: 12,
      label: t("users.parentAccount"),
      render: (row) =>
        row?.current_user?.username ? (
          <Tooltip
            title={t("users.defaultWarehouseFor", { name: row.current_user.username })}
          >
            <span>{row.current_user.username}</span>
          </Tooltip>
        ) : (
          "-"
        ),
      width: "200px",
    },
    {
      id: 9,
      label: t("users.registeredAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 10,
      label: t("users.actions"),
      render: (row) => (
        <CustomMenu
          row={row}
          setAddBalanceModal={setAddBalanceModal}
          setSubtractBalanceModal={setSubtractBalanceModal}
          setChangePassword={setChangePassword}
          setEditUserModal={setEditUserModal}
          setOpenDetailsModal={setOpenDetailsModal}
          setOpenClientsModal={setOpenClientsModal}
          setOpenHelperUsersModal={setOpenHelperUsersModal}
          setOpenProductsModal={setOpenProductsModal}
          setHistoryModal={setHistoryModal}
          setConfirmDelete={setConfirmDelete}
          setFormulaModal={setFormulaModal}
          setInvoicesHistoryModal={setInvoicesHistoryModal}
        />
      ),
      width: "200px",
      fixed: "right",
    },
  ];

  const fetchAllWarehouses = async (page, perPage, filter) => {
    const response = await getAllWarehouseUsers(page, perPage, filter);
    if (!response.error) {
      setWarehouses(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleStatusChange = async (e, record) => {
    setSearchLoader("WarehouseActivation");
    const updated = await changeWarehouseStatus(
      record?.id,
      e.target.checked ? "active" : "inactive",
    );

    if (updated.error) {
      setSearchLoader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
    } else {
      setWarehouses((prevWarehouses) => {
        return {
          ...prevWarehouses,
          data: prevWarehouses?.data?.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  status: updated?.data?.result?.status,
                }
              : item,
          ),
        };
      });
      setSearchLoader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text:
            updated?.data?.result?.status === "active"
              ? t("users.statusActive", { name: updated?.data?.result?.name ?? t("users.warehouseFallback") })
              : t("users.statusInactive", { name: updated?.data?.result?.name ?? t("users.warehouseFallback") }),
          severity:
            updated?.data?.result?.status === "active" ? "success" : "info",
        };
      });
    }
  };

  const handleUserStatusChange = async (e, record) => {
    setSearchLoader("UserActivation");
    const updated = await updateAccountStatus(record?.user);
    if (updated.error) {
      setSearchLoader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
    } else {
      setWarehouses((prevWarehouses) => {
        return {
          ...prevWarehouses,
          data: prevWarehouses?.data?.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  user: {
                    ...item.user,
                    account_status: updated?.data?.result?.account_status,
                  },
                }
              : item,
          ),
        };
      });
      setSearchLoader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status,
          )
            ? t("users.statusActive", { name: updated?.data?.result?.username ?? t("users.userFallback") })
            : t("users.statusInactive", { name: updated?.data?.result?.username ?? t("users.userFallback") }),
          severity: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status,
          )
            ? "success"
            : "info",
        };
      });
    }
  };

  const handleDeleteUser = async (record) => {
    // console.log("logger===", record);
    setStatusUpdating(true);
    const response = await deleteUserByAdmin(record.user.id);
    if (response.error) {
      setStatusUpdating(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setWarehouses((prevData) => {
        return {
          ...prevData,
          data: prevData?.data.filter(
            (item) => item.user.id !== record.user.id,
          ),
        };
      });
      setStatusUpdating(false);
      setConfirmDelete(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("users.userDeletedSuccessfully"),
          severity: "success",
        };
      });
    }
  };

  const updateIndex = (id, formula) => {
    // console.log("updatedfrmula", id, formula);
    setFormulaModal({
      ...formulaModal,
      user: { ...formulaModal.user, formula_with_data: formula },
    });
    setWarehouses((prevShippers) => {
      return {
        ...prevShippers,
        data: prevShippers?.data.map((item) =>
          item.id === id
            ? { ...item, user: { ...item.user, formula_with_data: formula } }
            : item,
        ),
      };
    });
  };
  // console.log("invoicesHistoryModal", invoicesHistoryModal);
  return (
    <div>
      <InvoicesHistory
        open={invoicesHistoryModal.user}
        setOpen={setInvoicesHistoryModal}
        User={invoicesHistoryModal.user}
        setSnack={setSnack}
      />
      <ManageWarehouseFormula
        open={formulaModal}
        setOpen={setFormulaModal}
        setSnack={setSnack}
        updateIndex={updateIndex}
      />
      <AddBalance
        open={addBalanceModal.user}
        setOpen={setAddBalanceModal}
        setSnack={setSnack}
        updateUsers={setWarehouses}
      />
      <SubtractBalance
        open={subtractBalanceModal.user}
        setOpen={setSubtractBalanceModal}
        setSnack={setSnack}
        updateUsers={setWarehouses}
      />
      <PaymentsHistory
        open={historyModal}
        setOpen={setHistoryModal}
        setSnack={setSnack}
        User={historyModal.user}
      />
      <ChangePassword
        open={!!changePassword}
        setOpen={setChangePassword}
        previousData={changePassword}
        setSnack={setSnack}
        setUsers={setWarehouses}
      />
      <EditUser
        open={!!editUserModal}
        setOpen={setEditUserModal}
        previousData={editUserModal?.user}
        setSnack={setSnack}
        setUsers={setWarehouses}
      />
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteUser(confirmDelete)}
        text={t("users.doYouWantToDelete")}
        loader={statusUpdating}
      />
      <WarehouseDetails open={openDetailsModal} setOpen={setOpenDetailsModal} />
      <WarehouseClientList
        open={openClientsModal}
        setOpen={setOpenClientsModal}
        setSnack={setSnack}
      />
      <HelperUserList
        open={openHelperUsersModal}
        setOpen={setOpenHelperUsersModal}
        setSnack={setSnack}
      />
      <WarehouseProductList
        open={openProductsModal}
        setOpen={setOpenProductsModal}
        setSnack={setSnack}
      />
      <div className="actionbtn__needtobe_fixwidth">
        <WarehousesTable
          tableTitle={t("users.threePlTab")}
          tableId="warehouseListTableForAdmin"
          message={t("users.noWarehouseAvailableToDisplay")}
          searchPlaceHolder={t("users.searchThreePl")}
          columns={columns}
          data={warehouses}
          getAllData={fetchAllWarehouses}
        />
      </div>
    </div>
  );
};

export default WarehouseList;
